const mainBritishGreen = '#004225';
const mainBlack = 'black'

export default {
    mainColor: mainBlack,
    inActiveGrey : 'grey'
}